import * as React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import i18n from "i18n";
import { Icon, OverlayTrigger, Timestamp } from "components/common";
import { formatInterval } from "aiagent/utils";
const DetailTitle = styled.dt`
  float: left;
  clear: left;
`;
const DetailValue = styled.dd(
  ({ theme }) => css`
    margin-left: 180px;
    overflow-wrap: break-word;

    &:not(:last-child) {
      border-bottom: 1px solid ${theme.colors.variant.lightest.default};
      margin-bottom: 5px;
      padding-bottom: 5px;
    }
  `
);
const DetailsOverlayTrigger = styled(OverlayTrigger)`
  vertical-align: bottom;
`;
const detailsPopover = (workflow) => /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement(DetailTitle, null, i18n.t("scheduling_cell.last_execution", { ns: "enterprise_ai" })), /* @__PURE__ */ React.createElement(DetailValue, null, workflow.last_run_at ? /* @__PURE__ */ React.createElement(Timestamp, { dateTime: workflow.last_run_at }) : i18n.t("agent_workflow_details.never", { ns: "enterprise_ai" })), /* @__PURE__ */ React.createElement(DetailTitle, null, i18n.t("scheduling_cell.next_execution", { ns: "enterprise_ai" })), /* @__PURE__ */ React.createElement(DetailValue, null, workflow.next_run_at ? /* @__PURE__ */ React.createElement(Timestamp, { dateTime: workflow.next_run_at }) : i18n.t("scheduling_cell.not_scheduled_short", { ns: "enterprise_ai" })));
const SchedulingCell = ({ workflow }) => {
  const { t } = useTranslation("enterprise_ai");
  if (workflow.disabled || !workflow.interval_ms) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, t("scheduling_cell.not_scheduled"));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, t("scheduling_cell.runs_every", { interval: formatInterval(workflow.interval_ms) }), " ", /* @__PURE__ */ React.createElement(
    DetailsOverlayTrigger,
    {
      trigger: "click",
      rootClose: true,
      placement: "left",
      title: t("scheduling_cell.details_title", { title: workflow.title }),
      overlay: detailsPopover(workflow),
      width: 500
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "info", title: t("scheduling_cell.details_title", { title: workflow.title }), bsStyle: "info" })
  ));
};
export default SchedulingCell;
